export enum Status {
    Do = 'do',
    Wait = 'wait',
    Done = 'done',
    Trash = 'trash'
}
